import { unionBounds, type Bounds } from "../../components/preview-canvas/metadata-bounds";
import { ART_HEIGHT, ART_WIDTH } from "../schedule-art/art-canvas";
import { findImage } from "../schedule-history/image-registry";

export function artworkPlacement(source: string) {
  const fallback = { point: [ART_WIDTH / 2, ART_HEIGHT / 2], textOffset: [0, 0], suggested: false };
  const image = findImage(source);
  if (!image) return fallback;
  const canvas = document.createElement("canvas");
  canvas.width = 240;
  canvas.height = 135;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) return fallback;
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  const { data } = context.getImageData(0, 0, canvas.width, canvas.height);
  const rows: Bounds[] = [];
  for (let y = 0; y < canvas.height; y++) {
    let left = canvas.width;
    let right = -1;
    for (let x = 0; x < canvas.width; x++) {
      if (data[(y * canvas.width + x) * 4 + 3]! < 32) continue;
      left = Math.min(left, x);
      right = x;
    }
    if (right >= left) rows.push({ x: left, y, width: right - left + 1, height: 1 });
  }
  const bounds = unionBounds(rows);
  const area = bounds ? bounds.width * bounds.height / (canvas.width * canvas.height) : 0;
  // A tiny mark or a full opaque canvas does not identify a useful placement region.
  if (!bounds || area < 0.01 || area > 0.8 || bounds.width < 12 || bounds.height < 9) return fallback;
  return {
    point: [Math.round(bounds.x * 8), Math.round(bounds.y * 8)],
    textOffset: [Math.round(bounds.width * 4), Math.round(bounds.height * 4)],
    suggested: true,
  };
}
